export default "__VITE_ASSET__007c5dda__"